import React from "react";
import style from "./ChipSelect.module.scss";
import ChipInfoIcon from "../../../static/images/info.svg";
import Tooltip from "../Tooltip/tooltip";

const defaultGetKey = (o) => o.key;
const defaultGetLabel = (o) => o.value;
const defaultGetDescription = (o) => o.description;

const ChipSelect = ({
  name,
  value,
  onChange,
  options,
  disabled = false,
  getOptionKey = defaultGetKey,
  getOptionLabel = defaultGetLabel,
  getOptionDescription = defaultGetDescription,
}) => {
  const safeOptions = Array.isArray(options) ? options : [];
  return (
    <div className={style.chip_group} role="radiogroup" aria-label={name}>
      {safeOptions.map((option) => {
        const key = getOptionKey(option);
        const label = getOptionLabel(option);
        const description = getOptionDescription(option);
        const isSelected = value === key;
        const hasDesc = description && description !== "-" && description !== "None";

        return (
          <button
            key={key}
            type="button"
            role="radio"
            aria-checked={isSelected}
            disabled={disabled}
            className={`${style.chip} ${isSelected ? style.chip_selected : ""}`}
            onClick={() => onChange(name, key)}
          >
            {hasDesc && (
              <Tooltip placement="bottom" width="400px" content={description}>
                <img src={ChipInfoIcon} alt="" className={style.chip_icon} />
              </Tooltip>
            )}
            <span>{label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ChipSelect;
